import React, { ReactElement } from 'react';

export enum SpinnerScheme {
    dark = 'dark',
    light = 'light',
}

const noFill = 'transparent';
const schemePallettes = {
    [SpinnerScheme.dark]: [
        ['#fff', '#ddd'],
        ['#ddd', '#bbb'],
        ['#bbb', '#999'],
        ['#999', '#777'],
        ['#777', '#666'],
        ['#666', '#666459'],
    ],
    [SpinnerScheme.light]: [
        [noFill, noFill],
        [noFill, noFill],
        [noFill, noFill],
        ['#fff', '#fff'],
        ['#fff', '#fff'],
        ['#fff', '#fff'],
    ],
};

const SvgSpinner = (props: React.SVGProps<SVGSVGElement> & { scheme?: SpinnerScheme }): ReactElement => {
    const { scheme = SpinnerScheme.dark } = props;
    const pallette = schemePallettes[scheme];

    return (
        <svg width="100" height="100" viewBox="0 0 300 300" {...props}>
            <linearGradient id="a" x2="1" y2="1">
                <stop offset="20%" stopColor={pallette[0][0]} />
                <stop offset="100%" stopColor={pallette[0][1]} />
            </linearGradient>
            <linearGradient id="b" x1=".5" x2=".5" y2="1">
                <stop offset="0%" stopColor={pallette[1][0]} />
                <stop offset="100%" stopColor={pallette[1][1]} />
            </linearGradient>
            <linearGradient id="c" x1="1" x2="0" y2="1">
                <stop offset="0%" stopColor={pallette[2][0]} />
                <stop offset="100%" stopColor={pallette[2][1]} />
            </linearGradient>
            <linearGradient id="d" x1="1" y1="1" x2="0">
                <stop offset="0%" stopColor={pallette[3][0]} />
                <stop offset="100%" stopColor={pallette[3][1]} />
            </linearGradient>
            <linearGradient id="e" x1=".5" y1="1" x2=".5">
                <stop offset="0%" stopColor={pallette[4][0]} />
                <stop offset="100%" stopColor={pallette[4][1]} />
            </linearGradient>
            <linearGradient id="f" y1="1" x2="1">
                <stop offset="0%" stopColor={pallette[5][0]} />
                <stop offset="100%" stopColor={pallette[5][1]} />
            </linearGradient>
            <path d="M150 30a120 120 0 0 1 103.923 60.2" fill="none" stroke="url(#a)" strokeWidth="16" />
            <path d="M253.923 90a120 120 0 0 1 0 120" fill="none" stroke="url(#b)" strokeWidth="16" />
            <path d="M254.523 209A120 120 0 0 1 149.6 270" fill="none" stroke="url(#c)" strokeWidth="16" />
            <path d="M150 270a120 120 0 0 1-103.923-60" fill="none" stroke="url(#d)" strokeWidth="16" />
            <path d="M46.777 211a120 120 0 0 1-1.3-120" fill="none" stroke="url(#e)" strokeWidth="16" />
            <path d="M44.948 92A120 120 0 0 1 149.87 30" fill="none" stroke="url(#f)" strokeWidth="16" />
        </svg>
    );
};

export default SvgSpinner;
